import { render } from "./HeroComponent.vue?vue&type=template&id=2066f173&scoped=true"
import script from "./HeroComponent.vue?vue&type=script&lang=js"
export * from "./HeroComponent.vue?vue&type=script&lang=js"

import "./HeroComponent.vue?vue&type=style&index=0&id=2066f173&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2066f173"]])

export default __exports__